"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withOutsideClick = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_onclickoutside_1 = tslib_1.__importDefault(require("react-onclickoutside"));
function withOutsideClick(methodName) {
    // https://github.com/Pomax/react-onclickoutside#ie-does-not-support-classlist-for-svg-elements
    if (typeof SVGElement !== "undefined" &&
        !("classList" in SVGElement.prototype)) {
        Object.defineProperty(SVGElement.prototype, "classList", {
            get: function () {
                var _this = this;
                return {
                    contains: function (className) {
                        return _this.className.baseVal.split(" ").indexOf(className) !== -1;
                    },
                };
            },
        });
    }
    return function (WrappedComponent) {
        var Component = react_onclickoutside_1.default(WrappedComponent, {
            handleClickOutside: function (instance) { return instance[methodName]; },
        });
        return (function (props) {
            return react_1.default.createElement(Component, tslib_1.__assign(tslib_1.__assign({}, props), { outsideClickIgnoreClass: "ignore-outside-click" }));
        });
    };
}
exports.withOutsideClick = withOutsideClick;
//# sourceMappingURL=with-outside-click.js.map